import styled from "styled-components";

export const GradientCol = styled("div")`
    position: absolute;
    top: 0;
    right: 0;
    z-index: -1;
    background: radial-gradient(
        104.52% 168.7% at 0% 0%,
        rgba(0, 87, 255, 0.2) 0%,
        rgba(83, 230, 177, 0.2) 33.12%,
        rgba(245, 198, 66, 0.2) 56.23%,
        rgba(227, 106, 132, 0.2) 74.51%,
        rgba(192, 80, 207, 0.2) 100%
    );
    width: 42.0rem;
    height: 78.0rem;

    @media screen and (min-width: 1441px) {
        width: calc((100vw - 1440px)/2 + 42.0rem);
    }

    @media screen and (max-width: 767px) {
        width: 59.015vw;
    }
`;
